import request from '../utils/request'

//获取权限验证配置
export function getAppidApi(params) {
  return request({
    method: 'get',
    url: '/api/wechat/config',
    params
  })
}

//获取家长信息&&学生信息
export function getUserInfoApi(params) {
  return request({
    method: 'get',
    url: '/api/wechat/user/info',
    params
  })
}

